import React from 'react';
import { Link } from 'react-router-dom';
import workflowImg from '../assets/dworkflow.png';
import integratedImagingImg from '../assets/3dmage.png';
import complianceImg from '../assets/complicance.png';

const specialties = [
  {
    id: 'general',
    title: 'General Dentistry',
    description: 'Comprehensive dental care for patients of all ages, focusing on preventive care and overall oral health.',
    icon: '🦷',
    image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=800&auto=format&fit=crop&q=60',
    features: [
      'Preventive Care',
      'Restorative Treatments',
      'Emergency Services',
      'Regular Check-ups'
    ]
  },
  {
    id: 'orthodontics',
    title: 'Orthodontics',
    description: 'Specialized care for teeth alignment and bite correction using advanced orthodontic solutions.',
    icon: '😁',
    image: 'https://images.unsplash.com/photo-1629909615184-74f495363b67?w=800&auto=format&fit=crop&q=60',
    features: [
      'Traditional Braces',
      'Clear Aligners',
      'Retainers',
      'Early Intervention'
    ]
  },
  {
    id: 'cosmetic',
    title: 'Cosmetic Dentistry',
    description: 'Transform your smile with our advanced cosmetic dental procedures and treatments.',
    icon: '✨',
    image: 'https://images.unsplash.com/photo-1629909615184-74f495363b67?w=800&auto=format&fit=crop&q=60',
    features: [
      'Teeth Whitening',
      'Veneers',
      'Dental Bonding',
      'Smile Makeovers'
    ]
  },
  {
    id: 'pediatric',
    title: 'Pediatric Dentistry',
    description: 'Specialized dental care for children, creating a positive and comfortable dental experience.',
    icon: '👶',
    image: 'https://images.unsplash.com/photo-1629909615184-74f495363b67?w=800&auto=format&fit=crop&q=60',
    features: [
      'Child-Friendly Environment',
      'Preventive Care',
      'Early Education',
      'Growth Monitoring'
    ]
  },
  {
    id: 'endodontics',
    title: 'Endodontics',
    description: 'Expert root canal treatment and care for the dental pulp and surrounding tissues.',
    icon: '🔬',
    image: 'https://images.unsplash.com/photo-1629909615184-74f495363b67?w=800&auto=format&fit=crop&q=60',
    features: [
      'Root Canal Therapy',
      'Pulp Treatment',
      'Trauma Care',
      'Pain Management'
    ]
  },
  {
    id: 'periodontics',
    title: 'Periodontics',
    description: 'Specialized care for gum health and treatment of periodontal diseases.',
    icon: '🦷',
    image: 'https://images.unsplash.com/photo-1629909615184-74f495363b67?w=800&auto=format&fit=crop&q=60',
    features: [
      'Gum Disease Treatment',
      'Dental Implants',
      'Gum Surgery',
      'Maintenance Care'
    ]
  }
];

const Specialties = () => {
  const benefits = [
    {
      title: "Specialty-Specific Workflows",
      description: "Customized workflows designed for your specific dental specialty",
      image: workflowImg,
      icon: null
    },
    {
      title: "Integrated Imaging",
      description: "Seamless integration with all major imaging systems",
      image: integratedImagingImg,
      icon: null
    },
    {
      title: "Compliance Ready",
      description: "Built-in compliance features for your specialty",
      image: complianceImg,
      icon: null
    }
  ];

  return (
    <div className="pt-24 bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-b from-[#E5F0F3] to-white">
        <div className="container mx-auto px-6 py-16">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-[#1E2A4A] mb-6">
              Dental Specialties
            </h1>
            <p className="text-xl text-gray-600">
              Discover our comprehensive range of dental specialties, each designed to provide expert care for your specific needs
            </p>
          </div>
        </div>
      </div>

      {/* Specialties Grid */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {specialties.map((specialty) => (
            <div 
              key={specialty.id}
              className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300"
            >
              <div className="relative h-48">
                <img 
                  src={specialty.image} 
                  alt={specialty.title}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'https://via.placeholder.com/800x600?text=Dental+Specialty';
                  }}
                />
                <div className="absolute top-4 right-4 w-12 h-12 bg-white rounded-full flex items-center justify-center text-2xl shadow-lg">
                  {specialty.icon}
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-2xl font-bold text-[#1E2A4A] mb-3">
                  {specialty.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {specialty.description}
                </p>
                
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-800 mb-2">Key Services:</h4>
                  <ul className="grid grid-cols-2 gap-2">
                    {specialty.features.map((feature, index) => (
                      <li 
                        key={index}
                        className="flex items-center text-gray-600 text-sm"
                      >
                        <svg className="w-4 h-4 mr-2 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                        </svg>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                {specialty.id === 'pediatric' ? (
                  <Link 
                    to="/pediatric-dentistry"
                    className="block w-full bg-orange-500 text-white text-center py-3 rounded-xl font-semibold hover:bg-orange-600 transition-colors"
                  >
                    Learn More
                  </Link>
                ) : (
                  <Link 
                    to={`/specialties/${specialty.id}`}
                    className="block w-full bg-orange-500 text-white text-center py-3 rounded-xl font-semibold hover:bg-orange-600 transition-colors"
                  >
                    Learn More
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-[#1E2A4A] text-white py-16">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-4">
            Ready to Experience Expert Dental Care?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Schedule a consultation with our specialists today
          </p>
          <Link 
            to="/schedule-demo"
            className="inline-block bg-orange-500 text-white px-8 py-4 rounded-xl font-semibold hover:bg-orange-600 transition-colors"
          >
            Schedule a Consultation
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Specialties; 